module.exports = __webpack_public_path__ + "img/wavingPeopleIcon.907a010e.svg";